var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTextareaMore = function SvgTextareaMore(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 9,
    viewBox: "0 0 8.8 8.8",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeOpacity: 0.7,
    d: "M.5 8.278 8.278.5M4.742 8.278l3.293-3.293"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTextareaMore);
export default ForwardRef;